import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  DialogActions,
  DialogProps,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { ModalProps } from "../../types";
import { colorVariables, customValue } from "../../utils/colorVariable";
import ModalActions from "./ModalActions";

const Modal: React.FC<ModalProps> = ({
  modalMode,
  open,
  onClose,
  title,
  width,
  height = "auto",
  children,
  showCloseButton = true,
  className,
  actions,
  bgcolor,
  additional,
  background,
  isFullScreen,
  disableScroll,
  maxWidth,
}) => {
  const titleId = React.useId();

  const handleClose: NonNullable<DialogProps["onClose"]> = (_event, reason) => {
    if (reason === "backdropClick" && modalMode !== "view") {
      return;
    }
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth ?? false}
      fullScreen={isFullScreen}
      fullWidth
      scroll="paper"
      aria-labelledby={title ? titleId : undefined}
      className={className}
      // fullWidth
      PaperProps={{
        sx: {
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          width: {
            xs: "calc(100vw - 16px)",
            sm: width ?? "90vw",
          },
          maxWidth: {
            xs: "calc(100vw - 16px)",
            sm: "calc(100vw - 32px)",
          },
          height,
          maxHeight: {
            xs: "calc(100vh - 16px)",
            sm: "calc(100vh - 32px)",
          },
          m: { xs: 1, sm: 2 },
          borderRadius: { xs: 1, sm: customValue.borderRadius },
          bgcolor: bgcolor ? bgcolor : "#F5F5F5",
          boxSizing: "border-box",
          "@supports (height: 100dvh)": {
            maxHeight: {
              xs: "calc(100dvh - 16px)",
              sm: "calc(100dvh - 32px)",
            },
          },
          ...(isFullScreen && {
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            maxHeight: "100%",
            m: 0,
            borderRadius: 0,
          }),
        },
      }}
    >
      {(title || showCloseButton) && (
        <DialogTitle
          id={titleId}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: 44,
            px: 2,
            py: 0.5,
            flexShrink: 0,
            bgcolor: `${colorVariables.primary}`,
            background: background ?? "",
          }}
        >
          <Box
            sx={{
              fontWeight: "normal",
              fontSize: "16px",
              color: colorVariables.white,
              minWidth: 0,
              overflowWrap: "anywhere",
            }}
          >
            {title}
          </Box>
          {showCloseButton && (
            <IconButton
              onClick={onClose}
              size="small"
              sx={{
                ml: 2,
                flexShrink: 0,
              }}
            >
              <CloseIcon sx={{ color: colorVariables.white }} />
            </IconButton>
          )}
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          p: 1,
          minHeight: 0,
          overflowY: disableScroll ? "hidden" : "auto",
          overflowX: "hidden",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          p={1}
          minWidth={0}
        >
          {children}
        </Box>
      </DialogContent>
      {actions && (
        <DialogActions
          sx={{
            p: { xs: 1, sm: 2 },
            flexShrink: 0,
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          <ModalActions actions={actions} additional={additional} />
        </DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
